function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.28 11H17.2V6.92C17.2 6.2 16.72 6.2 16 6.2C15.28 6.2 14.8 6.2 14.8 6.92V11H10.72C10 11 10 11.48 10 12.2C10 12.92 10 13.4 10.72 13.4H14.8V17.48C14.8 18.2 15.28 18.2 16 18.2C16.72 18.2 17.2 18.2 17.2 17.48V13.4H21.28C22 13.4 22 12.92 22 12.2C22 11.48 22 11 21.28 11ZM6.88 11H2.72C2 11 2 11.48 2 12.2C2 12.92 2 13.4 2.72 13.4H6.88C7.6 13.4 7.6 12.92 7.6 12.2C7.6 11.48 7.6 11 6.88 11ZM6.88 17H2.72C2 17 2 17.48 2 18.2C2 18.92 2 19.4 2.72 19.4H6.88C7.6 19.4 7.6 18.92 7.6 18.2C7.6 17.48 7.6 17 6.88 17ZM6.88 5H2.72C2 5 2 5.48 2 6.2C2 6.92 2 7.4 2.72 7.4H6.88C7.6 7.4 7.6 6.92 7.6 6.2C7.6 5.48 7.6 5 6.88 5Z"
});

var SvgIcnInsert = function SvgIcnInsert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2B82F7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnInsert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-insert.64fca678.svg";
export { ForwardRef as ReactComponent };